<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12" v-if="!linkHash">
          <v-toolbar
            dark
            flat
            v-if="!linkExists"
          >
            <v-toolbar-title>Begär återställning av lösenord</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-tooltip bottom>
            </v-tooltip>
          </v-toolbar>
          <div v-if="validationErrors">
            <v-alert v-for="error in validationErrors.errors" :key="error">
              {{ error}}
            </v-alert>
          </div>
          <v-card-text>
            <v-form>

              <v-text-field
                label="E-postadress för kontot"
                name="email"
                type="text"
                v-model="email"
                required
                outlined
              ></v-text-field>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="createRecoveryLink">Skapa länk för återställning</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="elevation-12" v-if="linkExists">
          <v-toolbar
            dark
            flat
          >
            <v-toolbar-title>Sätt nytt lösenord för användare</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-tooltip bottom>
            </v-tooltip>
          </v-toolbar>
          <div v-if="validationErrors">
            <v-alert v-for="error in validationErrors.errors" :key="error">
              {{ error}}
            </v-alert>
          </div>
          <v-card-text v-if="linkExists">
            <v-form>

              <v-text-field
                label="Lösenord"
                name="password"
                type="password"
                v-model="password"
                required
                outlined
              ></v-text-field>

              <v-text-field
                id="password_confirmation"
                label="Bekräfta lösenord"
                name="password_confirmation"
                type="password"
                v-model="password_confirmation"
                required
                outlined
              ></v-text-field>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="resetPassword">Spara nytt lösenord</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import SweetAlert from '@/services/SweetAlert'

export default {
  data () {
    return {
      password: '',
      password_confirmation: '',
      email: '',
      validationErrors: [],
      linkHash: null,
      linkExists: false
    }
  },

  mounted () {
    this.linkHash = this.$router.currentRoute.params.linkHash
    const that = this
    if (this.linkHash) {
      this.fetchRecoveryLinkAction(this.linkHash).then(function () {
        that.linkExists = true
      })
        .catch(error => {
          SweetAlert.errorMessage('Fel vid hämtande av återställningslänk!', error.response.data.error)
        })
    }
  },

  methods: {
    ...mapActions(['resetPasswordAction', 'fetchRecoveryLinkAction', 'createRecoveryLinkAction']),
    // Will call the API and return the result
    resetPassword () {
      const that = this
      const recoveryLink = {
        recoveryLinkHash: this.linkHash,
        password: this.password,
        password_confirmation: this.password_confirmation
      }
      this.resetPasswordAction(recoveryLink)
        .then(() => {
          SweetAlert.successMessage('Lösenordet har uppdaterats!')
          that.$router.push('/login')
        })
        .catch(result => {
          SweetAlert.errorMessage('Återställning av lösenord misslyckades!', result.response.data.error)
        })
    },

    createRecoveryLink () {
      this.createRecoveryLinkAction(this.email)
        .then(() => {
          SweetAlert.successMessage('En återställningslänk has skickats till ' + this.email)
        })
        .catch(error => {
          SweetAlert.errorMessage('Lösenordet kunde inte återstållas!', error.response.data.error)
        })
    }
  }
}
</script>
